import axios from "axios";
import headers from "./Header";

// const api = axios.create();
class SdiOrganizationService {
   
   getSdiOrganizationById(id) {
		let url = '/api/sdi-organization/'+id
		return axios.get(url, {
			headers: headers(),
		})
	}
   getAllSdiOrganization(page, name, provinceCode, cityCode, roles) {
		let url = "/api/sdi-organizations?size=10"
		url += page ? '&page='+page : "&page=0";
		if (name) {
			url = url + "&name=" + name;
		}
		if (provinceCode) {
			url = url + "&provinceCode=" + provinceCode;
		}
		if (cityCode) {
			url = url + "&cityCode=" + cityCode;
		}
		if (Array.isArray(roles) && roles.length) {
			url = url + "&roles=" + roles.join(',');
		}
		return axios.get(url, {
			headers: headers(),
		})
	}
	getPembinaData(page, name, provinceCode, cityCode) {
		let url = "/api/pembina-data?size=10"
		url += page ? '&page='+page : "&page=0";
		if (name) {
			url = url + "&name=" + name;
		}
		if (provinceCode) {
			url = url + "&provinceCode=" + provinceCode;
		}
		if (cityCode) {
			url = url + "&cityCode=" + cityCode;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getProdusenData(page, name, provinceCode, cityCode) {
		let url = "/api/produsen-data?size=10"
		url += page ? '&page='+page : "&page=0";
		if (name) {
			url = url + "&name=" + name;
		}
		if (provinceCode) {
			url = url + "&provinceCode=" + provinceCode;
		}
		if (cityCode) {
			url = url + "&cityCode=" + cityCode;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getWalidata(page, name, provinceCode, cityCode) {
		let url = "/api/walidata?size=10"
		url += page ? '&page='+page : "&page=0";
		if (name) {
			url = url + "&name=" + name;
		}
		if (provinceCode) {
			url = url + "&provinceCode=" + provinceCode;
		}
		if (cityCode) {
			url = url + "&cityCode=" + cityCode;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
}
export default new SdiOrganizationService();